'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import Image from 'next/image';
import { Button } from '@src/components/Button/Button';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { defaultTopNavProps } from './TopNav.defaults';
import { type TopNavProps } from './TopNav.props';
export const TopNavDesktop = t0 => {
  const $ = _c(37);
  const props = t0 === undefined ? defaultTopNavProps : t0;
  const trackSelectNavCta = useTrackSelectNavCta();
  let t1;
  if ($[0] !== trackSelectNavCta) {
    t1 = menus => menus?.filter(_temp)?.map((menu_0, index) => {
      if (!menu_0?.hasDropdown) {
        return <LocalizedLink onClick={() => {
          trackSelectNavCta({
            "cta url": menu_0.href
          });
        }} key={menu_0?.title} className="block cursor-pointer py-4 transition-all hover:text-bodi-white" href={menu_0.href ?? ""} rel={menu_0.newTab ? "noopener noreferrer" : ""} target={menu_0.newTab ? "_blank" : "_self"}>{menu_0.title}</LocalizedLink>;
      }
      return <div data-testid={`nav-menu-${index}`} key={menu_0.title} className="group/link relative flex cursor-pointer items-center gap-2 py-4 transition-all hover:text-bodi-white">{menu_0.title}<ChevronDownIcon className="size-5 transition-all group-hover/link:rotate-180" /><div className="absolute top-14 left-1/2 z-20 hidden h-auto w-72 -translate-x-1/2 overflow-hidden rounded-[14px] border border-bodi-gray-dark bg-bodi-black-text text-body-md text-bodi-white shadow-lg group-hover/link:block"><div className="flex flex-col p-3">{menu_0?.items?.filter(_temp2)?.map((item_0, itemIdx) => <LocalizedLink data-testid={`nav-menu-${index}-item-${itemIdx}`} href={item_0.href ?? ""} key={item_0.title} className="rounded-[4px] p-3 transition-all hover:bg-bodi-gray-medium" rel={item_0.newTab ? "noopener noreferrer" : ""} target={item_0.newTab ? "_blank" : "_self"}>{item_0.title}</LocalizedLink>)}</div>{menu_0.hasFeaturedItemDesktop && menu_0?.featuredItemDesktop?.title && <LocalizedLink data-testid="menu-featured-item-desktop" onClick={() => {
            trackSelectNavCta({
              "cta url": menu_0.featuredItemDesktop?.href
            });
          }} href={menu_0?.featuredItemDesktop?.href ?? ""} className="block bg-bodi-accent-bright-500 p-4 text-center font-semibold text-bodi-black-text transition-all hover:bg-bodi-accent-bright-400" rel={menu_0?.featuredItemDesktop?.newTab ? "noopener noreferrer" : ""} target={menu_0?.featuredItemDesktop?.newTab ? "_blank" : "_self"}>{menu_0?.featuredItemDesktop?.title}</LocalizedLink>}</div></div>;
    });
    $[0] = trackSelectNavCta;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const renderMenus = t1;
  let t2;
  if ($[2] !== props.logo || $[3] !== trackSelectNavCta) {
    t2 = props?.logo?.src && <LocalizedLink onClick={() => {
      trackSelectNavCta({
        "cta url": props?.logo?.href
      });
    }} href={props?.logo?.href ?? ""} className="block"><Image src={props.logo.src} width={props?.logo?.desktopWidth} height={props?.logo?.desktopHeight} alt={props?.logo?.altText ?? ""} /></LocalizedLink>;
    $[2] = props.logo;
    $[3] = trackSelectNavCta;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.menus || $[6] !== renderMenus) {
    t3 = renderMenus(props.menus);
    $[5] = props.menus;
    $[6] = renderMenus;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex items-center">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== props.links?.logIn?.href || $[12] !== trackSelectNavCta) {
    t5 = () => {
      trackSelectNavCta({
        "cta url": props?.links?.logIn?.href
      });
    };
    $[11] = props.links?.logIn?.href;
    $[12] = trackSelectNavCta;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = props.links?.logIn?.href ?? "";
  const t7 = props.links?.logIn?.newTab ? "noopener noreferrer" : "";
  const t8 = props.links?.logIn?.newTab ? "_blank" : "_self";
  const t9 = props.links?.logIn?.title;
  let t10;
  if ($[14] !== t5 || $[15] !== t6 || $[16] !== t7 || $[17] !== t8 || $[18] !== t9) {
    t10 = <LocalizedLink onClick={t5} data-testid="logInBtn" href={t6} className="flex cursor-pointer gap-2 hover:text-bodi-white" rel={t7} target={t8}>{t9}</LocalizedLink>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props.links?.signUp?.href || $[21] !== trackSelectNavCta) {
    t11 = () => {
      trackSelectNavCta({
        "cta url": props?.links?.signUp?.href
      });
    };
    $[20] = props.links?.signUp?.href;
    $[21] = trackSelectNavCta;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = props.links?.signUp?.href ?? "";
  const t13 = props.links?.signUp?.newTab ? "noopener noreferrer" : "";
  const t14 = props.links?.signUp?.newTab ? "_blank" : "_self";
  const t15 = props.links?.signUp?.title;
  let t16;
  if ($[23] !== t15) {
    t16 = <Button className="[&>div]:px-8" size="small">{t15}</Button>;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t16) {
    t17 = <LocalizedLink onClick={t11} data-testid="signUpBtn" href={t12} rel={t13} target={t14}>{t16}</LocalizedLink>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t16;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t10 || $[32] !== t17) {
    t18 = <div className="ml-auto flex items-center">{t10}{t17}</div>;
    $[31] = t10;
    $[32] = t17;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t18 || $[35] !== t4) {
    t19 = <nav className="hidden h-20 w-full bg-bodi-black-text font-medium text-bodi-gray-butters lg:block"><Container className="h-full *:h-full"><div className="flex h-full items-center *:flex *:gap-8">{t4}{t18}</div></Container></nav>;
    $[34] = t18;
    $[35] = t4;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  return t19;
};
function _temp(menu) {
  return Boolean(menu.title);
}
function _temp2(item) {
  return Boolean(item.title);
}